var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBackwardShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42 0.219999L11.28 2.06L3.66 9.6L11.28 17.14L9.42 18.98L0.0199999 9.6L9.42 0.219999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackwardShort);
export default __webpack_public_path__ + "static/media/arrow-backward-short.a4bd427ff9dee017b9a2943f0057f447.svg";
export { ForwardRef as ReactComponent };